import { link } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { WithStyles, ITheme } from 'core/style/interfaces';
import React from 'react';
import { Broker } from 'site/graphql';

const styles = (theme: ITheme) =>
    createStyles({
        table: {
            display: 'block',
            overflowX: 'auto',
            borderCollapse: 'collapse',
            fontSize: 0.8125 + 'rem',

            [theme.breakpoints.down('xs')]: {
                whiteSpace: 'nowrap',
            },

            '& tr': {
                borderBottom: '1px solid #EEEEEE',
            },

            '& td': {
                padding: '4px 56px 4px 24px',
            },

            '& th': {
                color: 'rgba(0, 0, 0, 0.54)',
                fontWeight: 500,
                padding: '8px 56px 8px 24px',
            },
        },
        link: {
            ...link('#597DA3'),
        },
    });

type IBrokerOtherTableProps = {
    brokers: Broker[];
};

const BrokerOtherTable: React.StatelessComponent<IBrokerOtherTableProps & WithStyles<typeof styles>> = ({
    brokers,
    classes,
}) => (
    <table className={classes.table}>
        <thead>
            <tr>
                <th>Брокер</th>
                <th>Минимум</th>
                <th>Комиссия</th>
            </tr>
        </thead>
        <tbody>
            {brokers.map(broker => (
                <tr key={broker.id}>
                    <td>
                        <a className={classes.link} href={broker.link} target="_blank" rel="noopener noreferrer">
                            {broker.name}
                        </a>
                    </td>
                    <td>{broker.minimum ? broker.minimum : '-'}</td>
                    <td>{broker.commission ? broker.commission : '-'}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default injectSheet(styles, 'BrokerOtherTable')(BrokerOtherTable);
